import { useEffect } from "react";

interface PageSeoProps {
  title?: string;
  description?: string;
  ogImage?: string;
  noIndex?: boolean;
}

export default function PageSeo({ title, description, ogImage, noIndex }: PageSeoProps) {
  const fullTitle = title
    ? `${title} | FCMRE`
    : "FCMRE – First Class Management Real Estate";
  const desc =
    description ??
    "FCMRE provides full-service property management across New York City — retail, residential, and condominium buildings.";

  useEffect(() => {
    document.title = fullTitle;
    const setMeta = (name: string, content: string, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };
    setMeta("description", desc);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    if (ogImage) setMeta("og:image", ogImage, "property");
    if (noIndex) setMeta("robots", "noindex,nofollow");
  }, [fullTitle, desc, ogImage, noIndex]);

  return null;
}

